let elements = {
  // mainImage: {
  //   imagePath: 'games/page999_game112/img/paint.png',
  //   pos: {
  //     y: 0,
  //     x: 0,
  //   },
  // },
  stepper: {
    show: false,
    color: 'blue',
    orientation: 'bottom',
  },
  // withoutCheck: true,
  steps: [
    {
      imagePath: 'games/page012_game4/img/00.png',
      pos: {
        y: 0,
        x: 0,
      },
      width: 1920,
      height: 1080,
      controll: {
        text: '1',
        type: 'next',
        pos: {
          y: 1006,
          x: 24,
        },
        width: 56,
        height: 56,
        background: '#f99b00',
      },
    },
    {
      imagePath: 'games/page012_game4/img/01.png',
      pos: {
        y: 0,
        x: 0,
      },
      width: 1920,
      height: 1080,
      controll: {
        text: '2',
        type: 'next',
        pos: {
          y: 956,
          x: 315,
        },
        width: 56,
        height: 56,
        background: '#f99b00',
      },
    },
    {
      imagePath: 'games/page012_game4/img/03.png',
      pos: {
        y: 0,
        x: 0,
      },
      controll: {
        text: '3',
        type: 'next',
        pos: {
          y: 853,
          x: 315,
        },
        width: 56,
        height: 56,
        background: '#f99b00',
      },
      width: 1920,
      height: 1080,
    },
    {
      imagePath: 'games/page012_game4/img/03.png',
      width: 1920,
      height: 1080,
      pos: {
        y: 0,
        x: 0,
      },
      end: true,
    },
  ],
};

export default elements;
